// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Cj8L","inner":"Footer_inner__3LSL1","nextIcon":"Footer_nextIcon__GmXiy","innerLeft":"Footer_innerLeft__1-iN8"};